import React from 'react';
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {getCssSizeValue} from "@/utils/utils";
import * as ErrorPageLottie from "@/assets/lottie/404-pck.json";
import Reveal from "@/animations/Reveal";
import Button from "@/components/common/Buttons/Button";
import {useRouter} from "next/router";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

const Styled404PageWrapper = styled.div`
	width: 100%;
	height: 100svh;
	background-color: #e4e4e4;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	p.sorry {
		margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
        max-width: ${getCssSizeValue(180, BREAKPOINTS.MOBILE)};
        text-align: center;
        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
            max-width: ${getCssSizeValue(380, BREAKPOINTS.TABLET)};
        }
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
            max-width: unset;
        }
	}
`;

const LottieWrapper = styled.div`
	max-width: 80%;
	text-align: center;
    margin-bottom: ${getCssSizeValue(50, BREAKPOINTS.MOBILE)};
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        max-width: 50%;
        margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
    }
`

const defaultOptions = {
	loop: true,
	autoplay: true,
	animationData: ErrorPageLottie,
	rendererSettings: {
		preserveAspectRatio: 'xMidYMid slice'
	}
};

const ErrorPageComponent = ({globals}) => {
	const page404Text = globals?.page404Text || '';
	const page404ButtonText = globals?.page404ButtonText || '';
	const router = useRouter();
	return (
		<Styled404PageWrapper>
			<LottieWrapper>
				<Reveal onInView>
					<Lottie options={defaultOptions} isClickToPauseDisabled ariaRole={"generic"}/>
				</Reveal>
			</LottieWrapper>
			<Reveal onInView>
				<p className='sorry typo-borna typo-borna-10'>{page404Text}</p>
			</Reveal>
			<Reveal onInView>
				<Button
					onClick={() => router.push('/')}
				>{page404ButtonText}</Button>
			</Reveal>
		</Styled404PageWrapper>
	);
};

export default ErrorPageComponent;
